<template style="overflow:hidden">
	<div style="overflow:hidden">
		<!-- <el-button @click="BatchAppointment" type="primary" v-if="tableList.length==0">上传表格</el-button>
		<el-button @click="setTeacher" type="primary" v-if="tableList.length!=0">确认任职</el-button>
		<el-button @click="cancelTeachers" type="primary" v-if="tableList.length!=0">取消任职</el-button>
		<el-switch v-model="isReset" active-color="#13ce66" inactive-color="#ff4949" active-text="开启任职覆盖"
			inactive-text="关闭任职覆盖" style="margin-left: 10px;"></el-switch> -->
		<!-- 学段选择弹窗 -->
		<div style="display: flex;align-items: center;gap: 12px;margin-bottom: 10px;">
		  <!-- 上传配置区：无表格时显示 -->
		  <div v-if="tableList.length === 0" style="display: flex;align-items: center;gap: 12px;">
		    <el-select v-model="periodValue" placeholder="请选择年级" style="width: 180px;" @change="forOpen">
		      <el-option v-for="item in gradeList" :key="item.grade" :label="item.gradeName" :value="item.grade"></el-option>
		    </el-select>
		
		    <el-upload
		      class="upload-demo"
		      action=""
		      :auto-upload="false"
		      :on-change="ishandleFileChange"
		      :show-file-list="false"
		      accept=".xlsx, .xls"
		    >
		      <el-button type="primary">选择Excel文件</el-button>
		    </el-upload>
		
		    <span v-if="file.name">{{ file.name }}</span>
		    <el-button type="primary" @click="toBatchAppointment" :disabled="!isopen" v-if="isopen">开始解析导入</el-button>
		    <el-button type="text" @click="downloadExcel">下载批量任职模板</el-button>
		  </div>
		
		  <!-- 表格存在时：功能按钮 -->
		  <template v-else>
		    <el-button @click="reUpload" type="primary">重新上传</el-button>
		    <el-button @click="setTeacher" type="primary">确认任职</el-button>
		    <el-button @click="cancelTeachers" type="primary">取消任职</el-button>
		  </template>
		
		  <el-switch
		    v-model="isReset"
		    active-color="#13ce66"
		    inactive-color="#ff4949"
		    active-text="开启任职覆盖"
		    inactive-text="关闭任职覆盖"
		  ></el-switch>
		</div>
		<!-- 处理教师的任职列表 -->
		<div></div>
		<div style="height: 90vh;overflow-x: auto; ">
			<el-table ref="mainTable" :height="tableHeight" :data="tableList" height="75%" border
				style="margin-top: 10px;" :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#787eb8','font-weight':'400','color':'#fff'}">
				<el-table-column v-for="(col, index) in columnst" :key="index" :prop="col.prop" :label="col.label"
					:fixed="index <3 ? 'left' : false" :min-width="index <3 ?'100px' :'150px'" header-align="center">
					<template slot-scope="scope">
						<div v-if="col.label==='年级'">
							<div v-if='scope.row.rowList[col.index] && scope.row.rowList[col.index].gradeId!=""'>
								{{scope.row.rowList[col.index].name}}
							</div>
							<div v-else>
								<el-select
									:placeholder="(scope.row.rowList[col.index] && scope.row.rowList[col.index].name) || ''"
									:value="(scope.row.rowList[col.index] && scope.row.rowList[col.index].gradeId) || ''"
									@change="val => updateGrade(scope.row, col.index, val)">
									<el-option v-for="item in gradeList.filter(v=>v.period==periodValue)" :key="item.id"
										:label="item.name" :value="item.id">
									</el-option>
								</el-select>
								<p>
									<button type="reset" class="deletecss"
										@click="deleteClass(scope.row, col.index, val)">删除</button>
								</p>
							</div>
						</div>

						<!-- 2. 校区列安全判断 -->
						<div v-else-if="col.label==='校区'">
							<p v-if='scope.row.rowList[col.index] && scope.row.rowList[col.index].areaId!=""'>
								{{scope.row.rowList[col.index].name}}
							</p>
							<p v-else>
								<el-select
									:placeholder="(scope.row.rowList[col.index] && scope.row.rowList[col.index].name) || ''"
									:value="(scope.row.rowList[col.index] && scope.row.rowList[col.index].areaId) || ''"
									@change="val => updateArea(scope.row, col.index, val)">
									<el-option v-for="item in areaList" :key="item.areaId" :label="item.areaName"
										:value="item.areaId">
									</el-option>
								</el-select>
							</p>
						</div>

						<!-- 3. 班级列安全判断 -->
						<div v-else-if="col.label==='班级'">
							<p v-if='scope.row.rowList[col.index] && scope.row.rowList[col.index].classId!=""'>
								{{scope.row.rowList[col.index].name}}
							</p>
							<p v-else>
								<el-select
									:placeholder="(scope.row.rowList[col.index] && scope.row.rowList[col.index].name) || ''"
									:value="(scope.row.rowList[col.index] && scope.row.rowList[col.index].classId) || ''"
									@change="val => updateClass(scope.row, col.index, val)">
									<el-option
										v-for="item in PclassList.filter(v=>v.areaId==(scope.row.rowList[1] && scope.row.rowList[1].areaId)&&v.grade==(scope.row.rowList[0] && scope.row.rowList[0].gradeId))"
										:key="item.classId" :label="item.className" :value="item.classId">
									</el-option>
								</el-select>
							</p>
						</div>

						<!-- 4. 核心报错点：教师列循环安全兜底 -->
						<div v-else style="width: 120px;">
							<!-- 关键：兜底为空数组，彻底解决teacherlist undefined报错 -->
							<div v-for="(teacher, idx) in (scope.row.rowList[col.index] && scope.row.rowList[col.index].teacherlist) || []"
								:key="idx" header-align="center">
								<template>
									<div v-if="teacher.istype===1">
										{{teacher.teacherName}}
									</div>
									<div v-else-if='teacher.istype===0'>
										<el-select :value="teacher.teacherId" filterable
											:placeholder="teacher.teacherName"
											@change="(val) => updateTeacher(scope.row, col.index, idx, val)">
											<el-option v-for="item in teacherList || []" :key="item.teacherId"
												:label="item.teacherName+'('+(item.phone||item.newId)+')'"
												:value="item.teacherId" />
										</el-select>
										<p>
											<button type="reset" class="deletecss"
												@click="deleteTeacher(scope.row, col.index, idx, val)">删除</button>
											<button type="reset" class="instercss"
												@click="insetTeacher(scope.row, col.index, idx, val)">添加</button>
										</p>
									</div>
									<div v-else>
										<el-select :value="teacher.teacherId" filterable
											:placeholder="teacher.teacherName"
											@change="(val) => updateTeacher(scope.row, col.index, idx, val)">
											<el-option
												v-for="item in teacherList?.filter(v=>v.teacherName==teacher.teacherName)"
												:key="item.teacherId"
												:label="item.teacherName+'('+(item.phone||item.newId)+')'"
												:value="item.teacherId" />
										</el-select>
									</div>
								</template>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import * as XLSX from 'xlsx';
	import debounce from 'lodash/debounce';
	export default {
		props: {
			grade: {
				type: Number,
				default: 0
			},
			gradeList: {
				type: Array,
				default: []
			},
		},
		data() {
			return {
				// schoolPeriod: localStorage.getItem('schoolPeriod'), //学段id
				schoolId: localStorage.getItem('orgId'), //学校id
				periodList: [], //校区列表
				periodValue: '', //选择的年级
				file: {}, //上传的文件
				columns: [], //表头
				isReset: true,
				isopen: false, //是否可以点击上传的按钮
				areaList: [], //校区列表
				tableList: [], //渲染列表
				// gradeList: [], //年级列表
				classList: [], //班级列表
				PclassList: [], //当前学段的年级
				teacherList: [], //教师列表
				loading: null, //执行方法过程弹窗
				columnst: [], //表头数据
				subjectList: [], //当前选中学段学科列表
				subjectLists: [], //学校所有学科
				isBatchAppointment: false, //批量任职的弹窗
				tableData: [], //存储后续的处理的数据
				allData: [], // 存储解析后的所有数据，包括过滤空格和分割'/'的数据
			};
		},

		created() {
			if (this.grade) {
				this.periodValue = this.grade
			}
			//处理年级下拉
			this.getClass()
			//获取老师
			this.getTeacherList()
			if (this.areaList.length == 0) {
				this.getCampus()
			}
			this.toSubject()
		},
		computed: {
			tableHeight() {
				return window.innerHeight * 0.75;
			}
		},
		mounted() {
			this.$nextTick(() => {
				const mainBody = this.$refs.mainTable.$el.querySelector('.el-table__body-wrapper');
				const fixedBody = this.$refs.mainTable.$el.querySelector('.el-table__fixed-body-wrapper');
				if (!mainBody || !fixedBody) return;

				// 保存debounce后的函数引用，确保移除时正确匹配
				this.syncScroll = debounce(() => {
					fixedBody.scrollTop = mainBody.scrollTop;
				}, 100);

				mainBody.addEventListener('scroll', this.syncScroll);
			});
		},
		beforeDestroy() {
			// 组件销毁时正确移除事件监听
			const mainBody = this.$refs.mainTable?.$el?.querySelector('.el-table__body-wrapper');
			if (mainBody && this.syncScroll) {
				mainBody.removeEventListener('scroll', this.syncScroll);
			}
		},
		methods: {
			//取消批量设置
			cancelTeachers() {
				this.tableList = []
				this.columnst = []
				this.allData = []
				this.tableData = []
				this.file = {}
				this.isopen=false
				this.$emit('child-method-trigger', 'false');
			},
			reUpload() {
			  this.isopen = false
			  this.tableList = []
			  this.columnst = []
			  this.allData = []
			  this.tableData = []
			  this.file = {}
			  
			},
			toSubject() {
				let list = localStorage.getItem('subjectList')
				let subjectList = JSON.parse(list)
				this.subjectLists = subjectList
			},

			//下载任职模版
			downloadExcel() {
				let tableData = {
					header: ['年级', '校区', '班级', '班主任', '副班主任']
				}
				let gradeListNmae = [
					'', '一年级', '二年级', '三年级', '四年级', '五年级', '六年级',
					'七年级', '八年级', '九年级', '高一年级', '高二年级', '高三年级'
				]
				let subjectOption = []
				// 计算阶段码
				var stag = this.periodValue < 7 ? 1 : this.periodValue < 10 ? 2 : 2
				// 过滤学科
				let res = this.subjectLists.filter(v => v.stageCode == stag)
				// 组装学科列
				res.map((v, i) => {
					subjectOption.push({
						index: v.id + 1,
						position: v.roleType,
						subjectId: v.subjectId,
						subjectName: v.subjectName.replace(/[\r\n]/g, '')
					})
				})

				// 学科排序
				subjectOption = subjectOption?.sort((a, b) => a.index - b.index)
				// 学科追加到表头
				for (let i = 0; i < subjectOption.length; i++) {
					tableData.header.push(subjectOption[i].subjectName)
				}

				// ========== 组装表格数据：年级、校区、班级 来自 this.classList ==========
				const worksheetData = []
				// 先放入表头
				worksheetData.push(tableData.header)

				// 遍历班级列表，逐行填充数据
				this.classList.forEach(item => {
					// 1. 年级：根据 grade 从 gradeListNmae 取值
					const gradeName = gradeListNmae[item.grade] || ''
					// 2. 校区 areaName  3. 班级 className
					const row = [gradeName, item.areaName, item.className, '', '']
					// 班主任、副班主任留空，后面拼接学科列
					// 追加空列（对应各个学科单元格）
					subjectOption.forEach(() => {
						row.push('')
					})
					worksheetData.push(row)
				})

				// 生成Excel并下载
				const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
				const workbook = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
				XLSX.writeFile(workbook, `${gradeListNmae[this.periodValue]}批量任职模版.xlsx`);
			},
			//删除不符合学段的年级这行数据
			deleteClass(row, index, val) {
				this.tableList = this.tableList.filter(v => v.rindex != row.rindex)
			},
			//删除需要批量的任职老师
			deleteTeacher(row, index, val) {
				this.tableList[row.rindex - 1].rowList[index].teacherlist = this.tableList[row.rindex - 1].rowList[index]
					.teacherlist.filter((v, i) => i != val)
			},
			//新增学校教师
			insetTeacher(row, index, val) {

				//prompt
				var name = this.tableList[row.rindex - 1].rowList[index].teacherlist[val].teacherName
				this.$confirm(`你要新增：《${name}》老师账号`, '新增教师弹窗', {
					confirmButtonText: '添加',
					cancelButtonText: '取消',
				}).then(() => {
					this.openLogin(`添加<${name}>教师中`)
					this.API.post(this.API.school.postSchoolUserAdd, {
							name: name,
							schoolId: this.schoolId
						})
						.then((res) => {
							console.log('res', res)
							this.loading.close()
							this.getTeacherList()
						})
						.catch((error) => {
							this.loading.close()
							this.$message.error('添加失败')
						});
				})
			},
			
			cancelTeacher(id) {
				if (this.isReset === false) return
				//取消任职
				console.log('取消任职', id)
				return new Promise(resolve => {
					const mockData = this.API.deleted(this.API.school.deletedAssign + id).then(res => {
						return true
					})
					if (mockData === true) {
						resolve(true);
					} else {
						resolve(false);
					}
				});
			},
			async setTeacher() {
				let listNew = []
				let deleteList = []
				let isNOteacher = false
				this.tableList.map(v => {
					v.rowList?.map(a => {
						if (a.ltype == 3 && a.gradeId == '') {
							isNOteacher = true
						}
						if (a.ltype == 2 && a.areaId == '') {
							isNOteacher = true
						}
						if (a.ltype == 4 && a.classId == '') {
							isNOteacher = true
						}
						if (a.ltype == 5 && a.teacherlist.length != 0) {
							a.teacherlist.map(t => {
								if (t.teacherId == '') {
									isNOteacher = true
								}
							})
						}
					})
				})
				if (isNOteacher) return alert('存在未设置数据');
				//批量任职
				var number = this.tableList.length
				this.openLogin(`处理任职中...`)
				for (let i = 0; i < this.tableList.length; i++) {
					let arr = {}
					this.loading.text = `处理任职中...(${i+1}/${number})`
					var teacher = this.tableList[i].rowList.filter(v => v.ltype == 5 && v.teacherlist.length != 0)
					//查询这个班级的任职,获取列表

					var classId = this.tableList[i].rowList.filter(v => v.ltype == 4)[0].classId
					let deptId = this.tableList[i].rowList.filter(v => v.ltype == 4)[0]?.deptId || ''
					arr.classId = classId
					arr.grade = this.tableList[i].rowList.filter(v => v.ltype == 3)[0].gradeId
					arr.areaId = this.tableList[i].rowList.filter(v => v.ltype == 2)[0].areaId
					let teacherZ = await this.queryName(classId)
					for (let a = 0; a < teacher.length; a++) {
						//比对班级存在就跳过，不存在就创建。原来有的现在这个没有就取消任职
						var subjectName = teacher[a].subjectName
						// var subjectArr = this.subjectList.filter(y => y.subjectName == subjectName)[0]
						var subjectId = teacher[a].subjectId
						// console.log(subjectName,'subjectId',subjectId)
						console.log('teacher[a]', teacher[a])
						var position = teacher[a].position
						arr.position = teacher[a].position
						arr.subjectId = teacher[a].subjectId
						let teacherlist = teacher[a].teacherlist
						//如果是班主任并且钉钉id存在的情况下跳过，通过钉钉事件执行
						if (teacher[a].position == 8 && deptId != '') {
							// continue
						} else {
							let newT = teacherZ.filter(v => v.position == position && v.subjectId == subjectId)
							for (let t = 0; t < teacherlist.length; t++) {
								//如果存在同任职，例如position,subject,
								// console.log('newTnewT',newT)
								// console.log('teacherlist',teacherlist[t])
								if (newT.filter(r => r.teacherId == teacherlist[t].teacherId).length != 0) {
									newT = newT.filter(r => r.teacherId != teacherlist[t].teacherId)
								} else {
									arr.teacherId = teacherlist[t].teacherId
									// let obj=arr

									// console.log('arr',arr)
									//执行新增
									await this.addInfo({
										"teacherId": teacherlist[t].teacherId,
										'position': teacherlist[t].position,
										'subjectId': teacherlist[t].subjectId,
										"classId": classId,
										"grade": arr.grade,
										"areaId": arr.areaId,
										"subjectName": teacher[a].subjectName
									})
								}
								if (t == teacherlist.length - 1 && newT.length != 0) {
									deleteList.push(...newT)
									//执行取消任职
									// console.log('newT',newT)
									for (let q = 0; q < newT.length; q++) {
										//循环执行取消

										//因为返回里面没有teacherId,所以不执行取消
										await this.cancelTeacher(newT[q].id)
									}
								}
								if (i == this.tableList.length - 1 && a == teacher.length - 1 && t == teacherlist
									.length -
									1) {
									this.tableList = []
									this.columnst = []
									this.loading.close()
									this.$emit('child-method-trigger', 'true');
									
								}
							}
						}
					}
				
				}
				this.$emit("close","true")

			},
			//新增教师任职
			addInfo(arr) {
				console.log('增加任职', arr)
				// return

				var areaId = arr.areaId.toString()
				var classId = arr.classId
				var grade = Number(arr.grade)
				var teacherId = arr.teacherId
				var type = arr.position==''?(arr.subjectName=='班主任'?8:9):arr.position
				console.log('this.subjectLists', this.subjectLists)
				var subjectArr = this.subjectLists.filter(t=>t.subjectName == arr.subjectName)[0]
				console.log('subjectArr',subjectArr)
				if (!areaId || !classId || !grade || !teacherId || !type) return
				return new Promise(resolve => {
					const mockData = this.API.post(this.API.school.postAssignSave, {
						userId: arr.teacherId,
						classId: arr.classId,
						subjectId: arr.subjectId==''?0:arr.subjectId,
						roleType: type,
						schoolId: this.schoolId,
						gradeId: grade
					}).then(res => {

						return true
					}).catch(error => {
						return false
					})
					const results = mockData
					resolve(results);
				});
			},
			//选中教师
			updateTeacher(row, lie, idx, val) {
				var arr = this.teacherList.filter(v => v.teacherId == val)[0]
				this.allData[row.rindex - 1].rowList[lie].teacherlist[idx].teacherId = val
				this.allData[row.rindex - 1].rowList[lie].teacherlist[idx].istype = 1
				this.allData[row.rindex - 1].rowList[lie].teacherlist[idx].teacherName = arr.teacherName || ''
				this.allData[row.rindex - 1].rowList[lie].teacherlist[idx].userId = arr.userId || ''
			},
			//选择班级
			updateClass(row, lie, val) {
				var val = val.toString()
				this.allData[row.rindex - 1].rowList[lie].classId = val.toString()
				this.allData[row.rindex - 1].rowList[lie].name = this.PclassList.filter(v => v.classId === val)[0]
					?.className
				this.allData[row.rindex - 1].rowList[lie].deptId = this.PclassList.filter(v => v.classId === val)[0]
					?.deptId
			},
			//在调整完年级和校区后在执行一次班级的id比对
			forclassTWO(row, lie, val) {
				var area = this.allData[row.rindex - 1].rowList.filter(v => v.ltype == 2)[0]
				var grade = this.allData[row.rindex - 1].rowList.filter(v => v.ltype == 3)[0]
				if (area?.areaId != '' && grade?.gradeId != '') {
					//执行班级处理
					this.allData[row.rindex - 1].rowList = this.allData[row.rindex - 1].rowList.map(v => {
						if (v.ltype == 4) {
							var classArr = this.PclassList.filter(a => a.gradeId == area.gradeId && a.areaId ==
								area.areaId && a.className == v.name)
							if (classArr.length != 0) {
								v.classId = classArr[0].classId
								v.istype = 1
							}
						}
						return {
							...v
						}
					})
				}
			},
			//选择年级
			updateGrade(row, lie, val) {
				//替换年级属性
				this.allData[row.rindex - 1].rowList[lie].gradeId = val.toString()
				this.allData[row.rindex - 1].rowList[lie].name = this.gradeList.filter(v => v.id == val)[0]?.name
				//需要考虑班级的比对
				this.forclassTWO(row, lie, val)
			},
			//选择校区
			updateArea(row, lie, val) {
				//执行
				this.allData[row.rindex - 1].rowList[lie].areaId = val.toString()
				this.allData[row.rindex - 1].rowList[lie].name = this.areaList.filter(v => v.id == val)[0]?.areaName
				//需要考虑班级的比对
				this.forclassTWO(row, lie, val)
			},
			forOpen() {
				if (!this.periodValue || this.file.name) {
					this.isopen = false
				}
				if (this.periodValue && this.file?.name) {
					this.isopen = true
				}
			},
			//获取所有校区
			async getCampus() {
				await this.API.get(this.API.school.getSchoolAreaList, {
					schoolId: this.schoolId
				}).then((res) => {
					console.log('aaa', res.data)
					this.areaList = res.data.data?.map(v => {
						var areaId = v.id.toString()
						return {
							...v,
							areaId: areaId
						}
					});
				});
			},
			//批量任职的按钮方法
			BatchAppointment() {
				this.allData = []
				this.tableData = []
				this.columns = []
				if (this.periodList.length != 0) {
					this.periodValue = this.periodList[0].value
				}
				this.isBatchAppointment = true
			},
			//关闭弹窗
			closeBatchAppointment() {
				this.isBatchAppointment = false
				this.allData = []
				this.tableData = []
				this.columns = []
				this.file = {}
			},
			//执行转圈
			openLogin(text) {
				this.loading = this.$loading({
					lock: true,
					text: text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			//执行表格处理
			toBatchAppointment() {
				//先获取选中的学段学科
				this.isBatchAppointment = false
				this.tableList = []
				this.columnst = []
				this.openLogin('表格处理中...')
				this.filterClass()
				this.operFile()
			},
			filterClass() {
				this.PclassList = this.classList
				// if (this.periodValue == 1) {
				// 	this.PclassList = this.classList?.filter(v => v.grade < 7)
				// }
				// if (this.periodValue == 2) {
				// 	this.PclassList = this.classList?.filter(v => v.grade > 6 && v.grade < 10)
				// }
				// if (this.periodValue == 3) {
				// 	this.PclassList = this.classList?.filter(v => v.grade > 9 && v.grade < 13)
				// }
			},
			//获取班级列表
			getClass() {
				if (this.classList.length == 0) {
					this.API.get(this.API.school.getSchoolGradClass, {
						schoolId: this.schoolId,
						gradeId: this.periodValue
					}).then((res) => {

						res.data?.data?.map(v => {
							this.classList.push({
								classId: v.id,
								grade: v.initGrade,
								areaId: v.areaId,
								areaName: v.areaName,
								className: v.classAlias,
							})
						})

					})
				}
			},
			//对上传表格进行处理
			ishandleFileChange(file) {
				if (file.name.slice(-5) == '.xlsx' || file.name.slice(-4) == '.xls') {
					this.file = file
					this.forOpen()
				} else {
					this.file = {}
					this.isopen = false
					alert('上传的文件非.xlsx/.xls格式')
					this.forOpen()
				}
			},
			operFile() {
				const reader = new FileReader();
				reader.onload = (e) => {
					this.columns = []
					this.allData = []
					this.tableData = []
					const data = new Uint8Array(e.target.result);
					const workbook = XLSX.read(data, {
						type: 'array'
					});
					const firstSheetName = workbook.SheetNames[0];
					const worksheet = workbook.Sheets[firstSheetName];
					const jsonData = XLSX.utils.sheet_to_json(worksheet, {
						header: 1
					});
					// 处理表头
					if (jsonData[0].filter(v => v == '校区').length != 1) {
						this.loading.close()
						this.$message('不存在校区')
						return
					}
					if (jsonData[0].filter(v => v == '年级').length != 1) {
						this.loading.close()
						this.$message('不存在年级')
						return
					}
					if (jsonData[0].filter(v => v == '班级').length != 1) {
						this.loading.close()
						this.$message('不存在班级')
						return
					}

					function isheader(index) {

						var name = jsonData[0][index]
						return name
					}

					function istype(name, subjectList) {
						if (name == '校区') {
							return 2
						} else if (name == '年级') {
							return 3
						} else if (name == '班级') {
							return 4
						} else if (name == '序号') {
							return 1
						} else if (name == '班主任') {
							return 5
						} else if (subjectList?.filter(v => v.subjectName == name).length > 0) {
							return 5
						} else {
							return -1
						}
					}
					// 处理数据，过滤空行和无效的任职班级
					const processedData = [];
					var newJsonDatas = jsonData.filter(v => v.length != 0)
					const header = newJsonDatas[0];
					const dataRows = newJsonDatas.slice(1);
					const filteredDataRows = dataRows.filter(row => {
						const nonEmptyCount = row.reduce((count, cell) => {
							return count + (cell.trim() !== "" ? 1 : 0);
						}, 0);
						return nonEmptyCount >= 4;
					});
					let newJsonData = [header, ...filteredDataRows];
					for (let i = 1; i < newJsonData.length; i++) {
						let row = {};
						var jsonRow = newJsonData[i]
						const rowL = []
						for (let a = 0; a < jsonData[0].length; a++) {
							var labername = isheader(a) || ''
							var ltype = istype(labername, this.subjectLists)

							// 统一生成表头：第一行全量生成，确保列数和行数据完全匹配
							if (i === 1) {
								this.columns.push({
									index: a,
									prop: a.toString(),
									label: (jsonData[0][a] || '').replace(/\s+/g, ''),
									name: (jsonData[0][a] || '').replace(/\s+/g, '')
								})
							}

							// 统一生成行数据：所有列都生成完整默认对象，禁止空对象
							const rowItem = {
								tablename: labername.replace(/\s+/g, ''),
								Lindex: a,
								subjectName: ltype === 5 ? labername : '',
								prop: a.toString(),
								label: (jsonRow[a] || '').replace(/\s+/g, ''),
								ltype: ltype, // 统一赋值，即使是-1也有值
								name: (jsonRow[a] || '').replace(/\s+/g, ''),
								gradeId: '',
								areaId: '',
								classId: '',
								teacherlist: [], // 提前初始化teacherlist为空数组，彻底解决undefined
								subjectId: '',
								position: ''
							}
							rowL.push(rowItem)
						}
						if (rowL.length != 0) {
							processedData.push({
								rindex: i,
								rowList: rowL
							});
						}
					}

					// 过滤空格数据行
					this.tableData = processedData
					this.allData = this.tableData
					this.file = {}
					this.forTable()
				};
				reader.readAsArrayBuffer(this.file.raw);
			},
			//执行数据处理逻辑
			forTable() {
				var areaIndex = this.columns.filter(v => v.name == '校区')[0]?.index
				var gradeIndex = this.columns.filter(v => v.name == '年级')[0]?.index
				var classIndex = this.columns.filter(v => v.name == '班级')[0]?.index
				var rowIndex = this.columns.filter(v => v.name == '序号')[0]?.index
				//先执行校区逻辑
				this.loading.text = '处理校区中...'
				this.forArea(areaIndex)
				//判断年级
				this.loading.text = '处理年级中...'
				this.forgrade(gradeIndex)
				//判断班级
				this.loading.text = '处理班级中...'
				this.forClass(areaIndex, gradeIndex, classIndex)
				this.loading.text = '处理教师中...'
				this.forTeacher()
				//执行老师判断
				this.loading.close()
				//结束处理，渲染表格数据
				this.tableList = this.allData
				this.columnst = this.columns
			},
			//INSER
			insterTeacher(row) {
				this.tableList = this.tableList?.map(v => {
					v.rowList = v.rowList?.map(a => {
						if (a.teacherlist.length != 0) {
							a.teacherlist = a.teacherlist?.map(t => {
								if (t.teacherId == '' && t.teacherName == row.teacherName) {
									t.userId = row.userId
									t.teacherId = row.teacherId
									t.istype = 1
								}
								return {
									...t
								}
							})
						}
						return {
							...a
						}
					})
					return {
						...v
					}
				})
			},
			forTeacher() {
				this.allData?.map(v => {
					v.rowList = v.rowList?.map(a => {
						
						var teacherlist = []
						let subjectId=''
						let position=''
						if (a.ltype == 5 && a.name != '') {
							subjectId = this.subjectLists.filter(t => t.subjectName == a.subjectName)[0]?.subjectId || ''
							position = this.subjectLists.filter(t => t.subjectName == a.subjectName)[0]?.roleType || ''
							if(a.subjectName=='班主任'){
								subjectId=0
								position=8
							}
							if(a.subjectName=='副班主任'){
								subjectId=0
								position=9
							}
							let arr=this.subjectLists.filter(t => t.subjectName == a.subjectName)[0]
							if (a.name.indexOf(';') > -1) {
								var List = a.name.split(';').filter(p => p != '')
								for (let i = 0; i < List.length; i++) {
									
									var filerT = this.teacherList.filter(p => p.teacherName == List[i])
									if (filerT.length == 0) {
										teacherlist.push({
											teacherName: List[i],
											teacherId: '',
											userId: '',
											istype: 0,
											subjectId: subjectId,
											position: position,
										})
									} else if (filerT.length == 1) {
										teacherlist.push({
											teacherName: List[i],
											teacherId: filerT[0].teacherId,
											userId: filerT[0].userId,
											istype: 1,
											subjectId: subjectId,
											position: position,
										})
									} else {
										teacherlist.push({
											teacherName: List[i],
											teacherId: '',
											userId: '',
											istype: 2,
											subjectId: subjectId,
											position: position,
										})
									}
								}
							} else {

								var filerTr = this.teacherList.filter(p => p.teacherName == a.name)
								if (filerTr.length == 0) {
									teacherlist.push({
										teacherName: a.name,
										teacherId: '',
										userId: '',
										istype: 0,
										subjectId: subjectId,
										position: position,
									})
								} else if (filerTr.length == 1) {
									teacherlist.push({
										teacherName: a.name,
										teacherId: filerTr[0].teacherId,
										userId: filerTr[0].userId,
										istype: 1,
										subjectId: subjectId,
										position: position,
									})
								} else {
									teacherlist.push({
										teacherName: a.name,
										teacherId: '',
										userId: '',
										istype: 2,
										subjectId: subjectId,
										position: position,
									})
								}
							}
						}
						
						return {
							...a,
							"subjectId": subjectId ?subjectId:'',
							"position": position ?position:'',
							"teacherlist": teacherlist
						}
					})
					return {
						...v,
						delete: 0
					}
				})
			},
			//第一次判断判班级合法与否
			forClass(areaIndex, gradeIndex, classIndex) {
				console.log('this.PclassList',this.PclassList)
				console.log('this.allData',this.allData)
				console.log(areaIndex, gradeIndex, classIndex)
				this.allData = this.allData.map(v => {
					if (v.rowList[areaIndex].areaId != '' && v.rowList[gradeIndex].gradeId != '') {
						var classIdArr = this.PclassList.filter(a => a.grade == v.rowList[gradeIndex].gradeId && a
							.areaId == v.rowList[areaIndex].areaId && a.className == v.rowList[classIndex].name
						)
						if (classIdArr.length != 0) {
							v.rowList[classIndex].classId = classIdArr[0].classId.toString()
						} else {
							v.rowList[classIndex].classId = ''
						}
					} else {
						v.rowList[classIndex].classId = ''
					}
					return {
						...v
					}
				})
			},
			//判断年级是否合法
			forgrade(gradeIndex) {
				if (this.gradeList.length == 0) {
					var data = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '高一', '高二', '高三']
					for (let i = 0; i < data.length; i++) {
						var period = i < 6 ? 1 : i < 9 ? 2 : 3
						var name = data[i] + '年级'
						this.gradeList.push({
							id: (i + 1).toString(),
							name: name,
							period: period
						})
					}
				}
				console.log('年级',this.gradeList)
				var gradeList = this.gradeList
				for (let i = 0; i < this.allData.length; i++) {
					var data = this.allData[i].rowList
					if (gradeList.filter(v => v.gradeName == data[gradeIndex].name).length > 0) {

						var gradeId = gradeList.filter(v => v.gradeName == data[gradeIndex].name)[0].grade

						this.allData[i].rowList[gradeIndex].gradeId = gradeId.toString()
					} else {
						this.allData[i].rowList[gradeIndex].gradeId = ''
					}
				}
			},
			//判断是否存在校区
			forArea(areaIndex) {
				for (let i = 0; i < this.allData.length; i++) {
					var data = this.allData[i].rowList
					if (this.areaList.filter(v => v.areaName == data[areaIndex].name).length > 0) {
						var areaId = this.areaList.filter(v => v.areaName == data[areaIndex].name)[0].id
						this.allData[i].rowList[areaIndex].areaId = areaId
					} else {
						this.allData[i].rowList[areaIndex].areaId = ''
					}
				}
			},
			//获取所有教师
			getTeacherList() {
				if (this.teacherList.length == 0) {
					this.API.get(this.API.school.getUserList, {
						schoolId: this.schoolId,
						pageNumber: 0,
						pageSize: 1000,

					}).then(res => {
						console.log('rrr', res.data)
						this.teacherList = res.data?.data?.records?.map(v => {
							return {
								teacherId: v.id,
								teacherName: v.name.replace(/\s+/g, ''),
								newId: v.id,
								phone: v.username.slice(-4),
								userId: v.authId
							}
						})?.filter(v => v.roleType != 1)
					})
				}

			},
			queryName(classId) {
				return new Promise(resolve => {
					let data = []
					const mockData = this.API.get(this.API.school.getAssignClass + classId).then(res => {
						data = res.data.data?.map(v => {
							return {
								teacherName: v.teacherName || '', //不确定为什么会有空值
								subjectId: v.subjectId,
								teacherId: v.userId || '', //当前不存在该字段
								userId: v.userId || '', //当前不存在该字段
								id: v.id,
								position: v.roleType || 10 //任职的角色消失
							}
						})
						return data
					})
					const results = mockData
					resolve(results);
				});
			},
		},
	};
</script>

<style>
	.table-container {
		position: relative;
		overflow: hidden;
	}

	.deletecss {
		margin-right: 10px;
		background-color: white;
		color: red;
		border-color: red;
	}

	.instercss {
		left: 10px;
		background-color: white;
		color: blue;
		border-color: blue;
	}

	.el-table__fixed-body-wrapper {
		height: auto !important;
		overflow-y: hidden;
	}

	.el-table__fixed-body-wrapper {
		height: auto !important;
	}

	.isname {
		font-size: 10px;
		color: red;
	}

	.el-table__fixed-body-wrapper {
		height: calc(100% - 47px) !important;
		overflow-y: auto;
		/* position: fixed; /* 相对于视口定位 */
		/* top: 50%; */
		/* left: 50%; */
		/* line-height: 100%;'' */
		/* .isPeriod{ */
	}
	/* 核心：子弹窗固定视窗居中，确保不会出现位置偏移 */
	/deep/ .isPeriod {
	  position: fixed !important;
	  top: 50% !important;
	  left: 50% !important;
	  transform: translate(-50%, -50%) !important;
	  margin: 0 !important;
	  z-index: 2002 !important;
	}
	
	/* 核心：子弹窗遮罩层覆盖整个视窗，不会出现错位/只覆盖部分区域 */
	/deep/ .isPeriod + .v-modal {
	  position: fixed !important;
	  top: 0 !important;
	  left: 0 !important;
	  width: 100vw !important;
	  height: 100vh !important;
	  z-index: 2001 !important; /* 比子弹窗低，比父弹窗高，层级正确 */
	  background-color: rgba(0, 0, 0, 0.5) !important;
	}
	
	/* 修正下拉框层级，确保不会被弹窗遮挡 */
	/deep/ .el-select-dropdown {
	  z-index: 2003 !important;
	}
</style>